import { ErrorMessage, Field, Form, FormikProvider, useFormik, FieldArray } from "formik";
import { useEffect, useRef, useState } from "react";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { ERROR_MSG, MOBILE_VALIDATION } from "../../CommonUtils/contextVariables";
import { failureAlert, successAlertRefresh } from "../../CommonUtils/SweetAlerts";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import allowNumbersOnly, { getServiceFullName, handlePaste } from "../../CommonUtils/CommonValidations";
import { FaDownload } from "react-icons/fa";
import { downloadBase64Pdf } from "../../CommonUtils/ImagesBase64";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { GetNocServices } from "../../Reducers/AffiliationCommonservice";

export default function DegreeUniversityAssigningInsp(serviceType) {
  const location = useLocation();
  const NocServicesOptions = useSelector((state) => state?.commonMastersReducer?.nocservices);

  const InspcollCode = location.state?.collCode;
  const InspnocType = location.state?.nocType;
  const Inspinstname = location.state?.clgname;
  const openModal = location.state?.openModal;

  const noctype = location.state?.serviceType || "eop";
  // ********hooks********
  const [clgcmpltedstatus, setclgcmpltedstatus] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [InstName, setInstName] = useState([]);
  const [collcode, setcollcode] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [verificationType, setVerificationType] = useState("");
  const [scrutinyModal, setScrutinyModal] = useState(false);
  const [scrutinydata, setScrutinydata] = useState([]);
  const [teamMembersdata, setTeamMembersdata] = useState([]);
  const [teamStaffsdata, setTeamStaffdata] = useState({});
  const [conData, setConData] = useState([]);
  const [polyData, setPolyData] = useState([]);
  const [clgTable, setclgTable] = useState(false);
  const [assignedTeamData, setAssignedTeamData] = useState({ online: "", physical: "" });
  const userId = sessionStorage.getItem("user_id");

  const hasFetchedData = useRef(false);

  //   ********* validation*******
  const committeeValidationSchema = Yup.object().shape({
    nonScrutinyModalFields: Yup.array().of(
      Yup.object().shape({
        university: Yup.string().test("university-required-only-second", ERROR_MSG, function (value) {
          const match = this.path.match(/\d+/); // NOSONAR
          const index = match ? Number(match[0]) : -1;
          // Required only for index 1
          if (index === 1) {
            return !!(value && value.trim());
          }
          // Not required for other indexes
          return true;
        }),
        officerName: Yup.string().required(ERROR_MSG),
        deptName: Yup.string().test("deptName-required-only-second", ERROR_MSG, function (value) {
          const match = this.path.match(/\d+/); // NOSONAR
          const index = match ? Number(match[0]) : -1;
          if (index === 1) {
            return !!(value && value.trim());
          }
          return true;
        }),
        designation: Yup.string().required(ERROR_MSG),
        // gmail: Yup.string().email("Invalid email format").required(ERROR_MSG),
        cfmsIdNo: Yup.string().required(ERROR_MSG),
        conClgName: Yup.string().required(ERROR_MSG),
        fromDateInsp: Yup.string().required(ERROR_MSG),
        toDateInsp: Yup.string().required(ERROR_MSG),
        mobileNo: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number"),
      }),
    ),
  });
  const scrutinyValidationSchema = Yup.object().shape({
    scrutinyTeam: Yup.string().required("Required"),
  });

  //   *******initial values********
  const degreeUniFormik = useFormik({
    initialValues: {
      collegesTableData: [],
      nocType: noctype,
      nonScrutinyModalFields: Array.from({ length: 3 }, () => ({
        university: "",
        officerName: "",
        designation: "",
        gmail: "",
        cfmsIdNo: "",
        conClgName: "",
        collegeAssigned: "",
        fromDateInsp: "",
        toDateInsp: "",
        mobileNo: "",
      })),
      scrutinyTeam: "",
    },
    validationSchema: verificationType === "online_scrutiny" ? scrutinyValidationSchema : committeeValidationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (values) => {
      handleFinalSubmit(values, collcode, verificationType);
    },
  });
  console.log("Formik errors >>>", degreeUniFormik.errors);
  const handleFinalSubmit = (values, collCode, verificationTypeParam) => {
    let teamData = [];
    if (verificationTypeParam === "online_scrutiny") {
      const selectedMember = scrutinydata?.find((item) => item.cfms_id === values.scrutinyTeam);
      // ✅ scrutiny payload
      teamData = [
        {
          teamType: "teamHead",
          verificationType: verificationTypeParam,
          officerName: selectedMember?.emp_name ?? "",
          designation: selectedMember?.designation ?? "",
          gmail: selectedMember?.emailid ?? "",
          cfmsIdNo: selectedMember?.cfms_id ?? "",
          collegeAssigned: InstName ?? "",
          mobileNo: selectedMember?.mobile ?? "",
        },
      ];
    } else {
      // ✅ Committee Payload
      teamData = values.nonScrutinyModalFields
        .map((item, index) => {
          if (!item.officerName) return null;
          return {
            verificationType: verificationTypeParam,
            // ✅ Extra Field Based on Index
            teamType: index === 1 ? "teamHead" : "teamMember",
            officerName: item.officerName ?? "",
            designation: item.designation ?? "",
            gmail: item.gmail ?? "",
            cfmsIdNo: item.cfmsIdNo ?? "",
            conClgName: item.conClgName ?? "",
            collegeAssigned: InstName ?? "",
            fromDateInsp: item.fromDateInsp ?? "",
            toDateInsp: item.toDateInsp ?? "",
            mobileNo: item.mobileNo ?? "",
          };
        })
        .filter(Boolean);
    }

    // ✅ Final Payload (Common Structure)
    const payload = {
      collCode: Number(collCode),
      nocType: values?.nocType,
      teamData: teamData,
    };
    Swal.fire({
      text: "Are you sure you want to submit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel!",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const url = `${config.url.FAC_URL}saveInspectionAllotement`;
        CommonAxiosPost(url, payload)
          .then((res) => {
            if (res?.data?.scode === "01") {
              successAlertRefresh(res?.data?.sdesc);
            } else {
              failureAlert(res?.data?.sdesc);
            }
          })
          .catch((err) => {
            console.log("Submit Error >>>", err);
            failureAlert("Something went wrong");
          });
      }
    });
  };
  function GetInspData(value) {
    let url = config?.url?.FAC_URL + "getAlloteInsp/" + value;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        const allotData = (res?.data?.allot || []).map((row, index) => ({
          ...row,
          originalIndex: index,
        }));
        setclgcmpltedstatus(allotData);
        // setclgTable(true);
        // ✅ Map data before setting
        const formattedTableData = allotData.map((row) => ({
          user_id: row.user_id || "",
          coll_code: row.coll_code || "",
          // verification_type: row.verification_type || "",
          verification_type: row.online_team_data && row.physical_team_data ? "physical_committee" : row.online_team_data && !row.physical_team_data ? "online_scrutiny" : "",
          inst_type: row.inst_type || "",
          inst_name: row.inst_name || "",
          affl_insp_status: row.affl_insp_status || "",
          mobile_email: row.mobile_email || "",
          noc_type: row.noc_type || "",
          // officer_name: row.officer_name || "",
          online_team_data: row.online_team_data || "",
          physical_team_data: row.physical_team_data || "",
        }));
        degreeUniFormik.setFieldValue("collegesTableData", formattedTableData);
      } else {
        setclgcmpltedstatus([]);
        degreeUniFormik.setFieldValue("collegesTableData", []);
        // setclgTable(false);
      }
    });
  }
  function GetScrutinyData() {
    let url = config?.url?.FAC_URL + "getScrutinyCfmsDetails";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setScrutinydata(res?.data?.data);
      } else {
        setScrutinydata([]);
      }
    });
  }
  const [doesOnlineScrutinyExist, setDoesOnlineScrutinyExist] = useState("");
  function GetIsOnlineScrutinyDone(collcode) {
    let url = config?.url?.FAC_URL + "getshiftingscrutinycount/" + collcode;
    CommonAxiosGet(url).then((res) => {
      if (res?.data) {
        setDoesOnlineScrutinyExist(res?.data?.scode);

        if (res?.data?.scode === "01") {
          Swal.fire({
            icon: "warning",
            title: "Online Scrutiny Pending",
            text: "Online Shifting Scrutiny is pending for this college. Kindly complete it before proceeding with Physical Committee allocation.",
          });
        }
      } else {
        setDoesOnlineScrutinyExist("");
      }
    });
  }

  function GetTeamMembersData(collcode) {
    let url = config?.url?.FAC_URL + "getTeammembers/" + collcode;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setTeamMembersdata(res?.data?.data);
      } else {
        setTeamMembersdata([]);
      }
    });
  }

  function GetTeamStaffsData(ubCode, index) {
    let url = config?.url?.FAC_URL + "getTeamStaffData?ubCode=" + ubCode;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setTeamStaffdata((prev) => ({
          ...prev,
          [index]: res?.data?.data,
        }));
      } else {
        setTeamStaffdata((prev) => ({
          ...prev,
          [index]: [],
        }));
      }
    });
  }

  function getConvenerData() {
    let url = config?.url?.FAC_URL + "getConvynordata";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setConData(res?.data?.data);
      } else {
        setConData([]);
      }
    });
  }

  function getPolyData() {
    let url = config?.url?.FAC_URL + "getpolyprincipaldata";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setPolyData(res?.data?.data);
      } else {
        setPolyData([]);
      }
    });
  }

  useEffect(() => {
    if (!hasFetchedData.current) {
      GetNocServices();

      GetInspData(noctype);
      hasFetchedData.current = true;
    }
  }, [noctype]);

  async function getProceedingsDetails(collCode, noctype) {
    try {
      const res = await CommonAxiosGet(`${config.url.FAC_URL}shiftingallotteampdf/${collCode}/${noctype}`);

      if (res?.data?.status !== true) {
        failureAlert("Failed to fetch PDF.");
        return;
      }

      const base64Pdf = res?.data?.file;

      if (!base64Pdf) {
        failureAlert("No PDF data received.");
        return;
      }

      downloadBase64Pdf(base64Pdf, `${collCode}_college_Proceedings_report.pdf`);
    } catch (err) {
      console.error("Error fetching PDF:", err);
      failureAlert("Failed to load PDF.");
    }
  }
  const handleSubmitWithTouch = () => {
    const touchedFields = {};

    degreeUniFormik.values.nonScrutinyModalFields.forEach((_, index) => {
      // ✅ Add this — university touched only for index 1
      if (index === 1) {
        touchedFields[`nonScrutinyModalFields[${index}].university`] = true;
      }
      touchedFields[`nonScrutinyModalFields[${index}].officerName`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].deptName`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].designation`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].gmail`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].cfmsIdNo`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].conClgName`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].collegeAssigned`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].fromDateInsp`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].toDateInsp`] = true;
      touchedFields[`nonScrutinyModalFields[${index}].mobileNo`] = true;
    });
    degreeUniFormik.setTouched(touchedFields, true);
    degreeUniFormik.submitForm();
  };

  const handleOfficerChange = (index, selectedCfms) => {
    // find selected officer
    const selectedFaculty = (teamStaffsdata[index] || []).find((item) => item.fac_name === selectedCfms);
    // set officer name
    degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].officerName`, selectedCfms);
    if (selectedFaculty) {
      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].gmail`, selectedFaculty.email_id || "");
      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].cfmsIdNo`, selectedFaculty.cfms_id || "");
      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].mobileNo`, selectedFaculty.contact || "");
      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].conClgName`, selectedFaculty.univ_name || "");
      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].designation`, selectedFaculty.designation || "");
      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].deptName`, selectedFaculty.dept_name || "");
    }
  };

  // Find selected employee for Scrutiny
  const selectedScrutinyMember = scrutinydata?.find((item) => item.cfms_id === degreeUniFormik.values.scrutinyTeam);
  const iconBtn = {
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const downloadBtn = {
    ...iconBtn,
    backgroundColor: "#e6f9f0",
    color: "#059669",
  };
  // ****** reset formik data for modal popup*****
  const resetCommitteeFields = () => {
    degreeUniFormik.setFieldValue(
      "nonScrutinyModalFields",
      Array.from({ length: 3 }, () => ({
        university: "",
        officerName: "",
        deptName: "",
        designation: "",
        gmail: "",
        cfmsIdNo: "",
        conClgName: "",
        collegeAssigned: "",
        fromDateInsp: "",
        toDateInsp: "",
        mobileNo: "",
      })),
    );
    degreeUniFormik.setFieldValue("scrutinyTeam", "");
  };

  const handleClose = () => setShowModal(false);
  const handleScrutinyClose = () => setScrutinyModal(false);

  const Columns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>,
    },

    {
      id: "mobile_email",
      header: "Contact Details",
      accessorKey: "mobile_email",
      cell: ({ row }) => {
        const [mobile, email] = (row.original.mobile_email || "").split(",").map((item) => item.trim());

        return (
          <div style={{ textAlign: "left" }}>
            <div>{mobile}</div>
            <div>{email}</div>
          </div>
        );
      },
    },
    // {
    //   id: "user_id",
    //   header: "Inspection User Id",
    //   accessorKey: "user_id",
    //   meta: { style: { textAlign: "center" } },
    //   cell: ({ row }) => {
    //     if (row?.original?.noc_type?.toLowerCase() !== "shifting") {
    //       return null;
    //     }

    //     const physicalTeamData = row?.original?.physical_team_data;

    //     return <div>{physicalTeamData !== null ? `noc_${row?.original?.coll_code}` : row?.original?.user_id}</div>;
    //   },
    // },
    ...(degreeUniFormik?.values?.nocType === "shifting"
      ? [
        {
          id: "user_id",
          header: "Inspection User Id",
          accessorKey: "user_id",
          meta: { style: { textAlign: "center" } },
          cell: ({ row }) => {
            if (row?.original?.noc_type?.toLowerCase() !== "shifting") {
              return null;
            }

            const physicalTeamData = row?.original?.physical_team_data;

            return (
              <div>
                {physicalTeamData !== null
                  ? `noc_${row?.original?.coll_code}`
                  : row?.original?.user_id}
              </div>
            );
          },
        },
      ]
      : []),

    // {
    //   id: "noc_type",
    //   header: "NOC Type",
    //   accessorKey: "noc_type",
    //   meta: { style: { textAlign: "center" } },
    // },


    ...(userId !== "section_admin"
      ? [
        {
          id: "verificationType",
          header: "Verification Type",
          cell: ({ row }) => {
            const index = row.original.originalIndex;
            const nocType = row?.original?.noc_type;

            const isShifting = nocType === "shifting";

            return (
              <div style={{ minWidth: "200px" }}>
                <Field
                  as="select"
                  name={`collegesTableData[${index}].verification_type`}
                  className="form-control"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "physical_committee" || value === "virtual_committee") {
                      GetIsOnlineScrutinyDone(row.original.coll_code);
                    }
                  }}
                >
                  <option value="">---select---</option>
                  <option value="online_scrutiny">Online Scrutiny</option>
                  {isShifting && (
                    <>
                      <option value="physical_committee">Physical Committee</option>
                      <option value="virtual_committee">Virtual Committee</option>
                    </>
                  )}
                </Field>
              </div>
            );
          },
        },
      ]
      : []),

    {
      id: "online_team_data",
      header: "Assigned Team Member-Online Scrutiny",
      accessorKey: "online_team_data",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "physical_team_data",
      header: "Assigned Team Member-Physical Committee",
      accessorKey: "physical_team_data",
      meta: { style: { textAlign: "center" } },
      cell: ({ row }) => {
        const index = row.original.originalIndex;
        const isShifting = row.original.noc_type?.toLowerCase() === "shifting";

        const verificationType = degreeUniFormik?.values?.collegesTableData?.[index]?.verification_type || "";

        return (
          <div style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center" }}>
            <span>{row.original.physical_team_data || "-"}</span>
            {isShifting && verificationType === "physical_committee" && row?.original?.physical_team_data !== null && (
              <button
                style={downloadBtn}
                onClick={async () => {
                  const collCode = row.original.coll_code;

                  getProceedingsDetails(row.original.coll_code, row?.original?.noc_type);
                }}
                title="Download Report"
              >
                <FaDownload />
              </button>
            )}
          </div>
        );
      },
    },
    ...(userId !== "section_admin"
      ? [
        {
          id: "actions",
          header: "Mapping for Reset Password",
          cell: ({ row }) => {
            const rowVerificationType = degreeUniFormik?.values?.collegesTableData[row.original.originalIndex]?.verification_type || "";

            return (
              <div>
                <button
                  type="button"
                  className="btn btn-success btn-sm float-end rounded mb-2"
                  onClick={() => {
                    if ((rowVerificationType === "physical_committee" || rowVerificationType === "virtual_committee") && doesOnlineScrutinyExist === "01") {
                      Swal.fire({
                        icon: "warning",
                        title: "Online Scrutiny Pending",
                        text: "Online Shifting Scrutiny is pending for this college. Kindly complete it before proceeding with Physical Committee allocation.",
                      });
                      return;
                    }
                    if (!rowVerificationType) {
                      Swal.fire({
                        icon: "warning",
                        title: "Please select Verification Type",
                      });
                      return;
                    }
                    resetCommitteeFields();

                    setAssignedTeamData({
                      online: row.original.online_team_data || "",
                      physical: row.original.physical_team_data || "",
                    });

                    // Save selected row data
                    setcollcode(row.original.coll_code);
                    setVerificationType(rowVerificationType);

                    if (rowVerificationType === "online_scrutiny") {
                      setScrutinyModal(true);
                      GetScrutinyData();
                    } else {
                      setShowModal(true);
                      GetTeamMembersData(row?.original?.coll_code);
                      getConvenerData();
                      getPolyData();
                    }
                    setInstName(row.original.inst_name);
                  }}
                >
                  {rowVerificationType === "" ? "Assign Team" : "Re-Assign Team"}
                </button>
              </div>
            );
          },
        },
      ]
      : []),
  ];

  const filteredData = clgcmpltedstatus?.filter((item) => {
    // Check if at least one team member is assigned (online OR physical)
    const hasOnlineTeam = item.online_team_data && item.online_team_data.trim() !== "";
    const hasPhysicalTeam = item.physical_team_data && item.physical_team_data.trim() !== "";
    const isTeamAssigned = hasOnlineTeam || hasPhysicalTeam;

    if (filterType === "assign") return !isTeamAssigned; // Team NOT allotted
    if (filterType === "reassign") return isTeamAssigned; // Team allotted
    return true;
  });

  const assignCount = clgcmpltedstatus.filter((item) => {
    const hasOnlineTeam = item.online_team_data && item.online_team_data.trim() !== "";
    const hasPhysicalTeam = item.physical_team_data && item.physical_team_data.trim() !== "";
    return !(hasOnlineTeam || hasPhysicalTeam);
  }).length;

  const reassignCount = clgcmpltedstatus.filter((item) => {
    const hasOnlineTeam = item.online_team_data && item.online_team_data.trim() !== "";
    const hasPhysicalTeam = item.physical_team_data && item.physical_team_data.trim() !== "";
    return hasOnlineTeam || hasPhysicalTeam;
  }).length;
  useEffect(() => {
    if (openModal) {
      setShowModal(true);
      GetTeamMembersData(InspcollCode);
      getConvenerData();
      getPolyData();
    }
  }, [openModal]);


  const headerName = `Allot Team Member Report${degreeUniFormik.values.nocType
    ? ` - ${getServiceFullName(degreeUniFormik.values.nocType, NocServicesOptions)}`
    : ""
    }`;
  return (
    <>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <FormikProvider value={degreeUniFormik}>
          <Form onSubmit={degreeUniFormik.handleSubmit} onChange={degreeUniFormik.handleChange} className="affl-form">
            <bie.Row className="px-2 pt-3 mb-3 w-100">
              <h5 className="mb-3 innerheader-new">
                <span>Allot Team Member Report</span>
              </h5>
              {/* 
              <CommonFormHeading
    heading="Final Status"
    showBack
    backStep={-2}
/> */}
              {/* <CommonFormHeading
                heading="Final Status"
              /> */}
              <bie.Row>
                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                  <label
                    className="form-label mb-0"
                    style={{
                      color: "#0f766e",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      marginBottom: 0,
                    }}
                  >
                    Select NOC Type
                  </label>
                  <Field
                    as="select"
                    name="nocType"
                    className="form-control"
                    onChange={(e) => {
                      const value = e.target.value;
                      degreeUniFormik.setFieldValue("nocType", value);
                      // setclgTable(false);
                      GetInspData(value);
                    }}
                  >
                    <option value="">--select--</option>
                    {/* <option value="eop">EOP</option>
                    <option value="new_college">New College</option>
                    <option value="management">Management Change</option>
                    <option value="shifting">Shifting</option>
                    <option value="conversion_program">Conversion</option> */}
                    {NocServicesOptions
                      ?.filter((service) => service.is_active)
                      .map((service) => (
                        <option
                          key={service.nos_short_name}
                          value={service.nos_short_name}
                        >
                          {service.full_name}
                        </option>
                      ))}

                  </Field>
                </bie.Col>
              </bie.Row>
              {clgcmpltedstatus?.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    gap: "15px",
                    marginTop: "20px",
                    marginBottom: "20px",
                    borderBottom: "2px solid #ddd",
                    paddingBottom: "10px",
                  }}
                >
                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setFilterType("all");
                      }
                    }}
                    onClick={() => setFilterType("all")}
                    style={{
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      backgroundColor: filterType === "all" ? "#4f46e5" : "#f1f1f1",
                      color: filterType === "all" ? "#fff" : "#000",
                      fontWeight: "bold",
                    }}
                  >
                    📋 All ({clgcmpltedstatus.length})
                  </div>

                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setFilterType("assign");
                      }
                    }}
                    onClick={() => setFilterType("assign")}
                    style={{
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      backgroundColor: filterType === "assign" ? "#dc3545" : "#f1f1f1",
                      color: filterType === "assign" ? "#fff" : "#000",
                      fontWeight: "bold",
                    }}
                  >
                    🔁 Team Not Allotted ({assignCount})
                  </div>

                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setFilterType("reassign");
                      }
                    }}
                    onClick={() => setFilterType("reassign")}
                    style={{
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      backgroundColor: filterType === "reassign" ? "#168a43" : "#f1f1f1",
                      color: filterType === "reassign" ? "#fff" : "#000",
                      fontWeight: "bold",
                    }}
                  >
                    👥 Team Allotted ({reassignCount})
                  </div>
                </div>
              )}
              {filteredData?.length > 0 ? (
                <>
                  <div className="table-responsive">
                    <CommonReactTable
                      data={filteredData}
                      columns={Columns}
                      filename="University Assign Inspection"
                      headerName={headerName}
                      showFooter={false}
                      showPagination={false}
                      showExcel={true}
                      showPrint={false}
                      excelFileName="University Assign Inspection"
                    />
                  </div>
                </>
              ) : (
                <center className="text-danger h6">*** No Data Found ***</center>
              )}

              <bie.Modal show={showModal} onHide={handleClose} size="xl" dialogClassName="custom-modal-width">
                <bie.Modal.Header closeButton style={{ backgroundColor: "#bbc2e9" }}>
                  <bie.Modal.Title>Assigning Inspection Team to {InstName || Inspinstname} College</bie.Modal.Title>
                </bie.Modal.Header>

                <bie.Modal.Body style={{ overflowX: "auto" }}>
                  <FieldArray name="nonScrutinyModalFields">
                    {() => (
                      <div style={{ overflowX: "auto" }}>
                        {/* ***********Committee Convenor Details********** */}
                        <h5 className="mb-3 innerheader-new">
                          <span>Committee Convenor Details</span>
                        </h5>
                        <table table className="table table-bordered mt-2 ">
                          <thead className="table-primary">
                            <tr>
                              <th style={{ width: "180px" }}>University</th>
                              <th style={{ width: "180px" }}>Convenor Name</th>
                              <th style={{ width: "180px" }}>Department</th>
                              <th style={{ width: "140px" }}>Designation</th>
                              <th style={{ width: "150px" }}>Contact No</th>
                              <th style={{ width: "200px" }}>Email Id</th>
                              <th style={{ width: "160px" }}>CFMS id/Emp id</th>
                              <th style={{ width: "160px" }}>Convenor College Name</th>
                              <th style={{ width: "180px" }}>College Assigned</th>
                              <th style={{ width: "140px" }}>From Date</th>
                              <th style={{ width: "140px" }}>To Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[1].map((index) => (
                              <tr key={index}>
                                {/* University */}

                                <td>
                                  <Field
                                    as="select"
                                    name={`nonScrutinyModalFields[${index}].university`}
                                    className="form-control"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].university`, value);
                                      // Clear row fields
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].officerName`, "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].deptName`, "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].designation`, "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].gmail`, "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].cfmsIdNo`, "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].mobileNo`, "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].conClgName`, "");
                                      // Load officers row-wise
                                      GetTeamStaffsData(value, index);
                                    }}
                                  >
                                    <option value="">Select University</option>
                                    {teamMembersdata && teamMembersdata.length > 0 ? (
                                      teamMembersdata.map((item, idx) => (
                                        <option key={idx} value={item.ub_code}>
                                          {item.univ_name}
                                        </option>
                                      ))
                                    ) : (
                                      <option value="">No Data Available</option>
                                    )}
                                  </Field>
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].university`} component="div" className="text-danger" />
                                </td>

                                {/* Officer Name */}
                                <td>
                                  <Field
                                    as="select"
                                    name={`nonScrutinyModalFields[${index}].officerName`}
                                    className="form-control"
                                    disabled={!degreeUniFormik.values.nonScrutinyModalFields[index]?.university}
                                    onChange={(e) => {
                                      handleOfficerChange(index, e.target.value);
                                    }}
                                  >
                                    <option value="">Select Officer</option>

                                    {(teamStaffsdata[index] || []).length > 0 ? (
                                      (teamStaffsdata[index] || [])
                                        .filter((item) => !assignedTeamData.physical?.includes(item.fac_name))
                                        .map((item, idx) => (
                                          <option key={idx} value={item.fac_name}>
                                            {item.fac_name}
                                          </option>
                                        ))
                                    ) : (
                                      <option value="">No Staff Available</option>
                                    )}
                                  </Field>
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].officerName`} component="div" className="text-danger" />
                                </td>

                                {/* Department */}

                                <td>
                                  <Field name={`nonScrutinyModalFields[${index}].deptName`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].deptName`} component="div" className="text-danger" />
                                </td>

                                {/* Designation */}

                                <td>
                                  <Field name={`nonScrutinyModalFields[${index}].designation`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].designation`} component="div" className="text-danger" />
                                </td>

                                {/* Mobile */}

                                <td>
                                  <Field name={`nonScrutinyModalFields[${index}].mobileNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].mobileNo`} component="div" className="text-danger" />
                                </td>

                                {/* Email */}

                                <td>
                                  <Field name={`nonScrutinyModalFields[${index}].gmail`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].gmail`} component="div" className="text-danger" />
                                </td>

                                {/* CFMS */}

                                <td>
                                  <Field name={`nonScrutinyModalFields[${index}].cfmsIdNo`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].cfmsIdNo`} component="div" className="text-danger" />
                                </td>

                                {/* Convenor College */}

                                <td>
                                  <Field name={`nonScrutinyModalFields[${index}].conClgName`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].conClgName`} component="div" className="text-danger" />
                                </td>

                                {/* College Assigned */}

                                <td>
                                  <input value={InstName} disabled className="form-control" />

                                  <Field type="hidden" name={`nonScrutinyModalFields[${index}].collegeAssigned`} value={InstName} />
                                </td>

                                {/* From Date */}

                                <td>
                                  <Field
                                    type="date"
                                    name={`nonScrutinyModalFields[${index}].fromDateInsp`}
                                    className="form-control"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // update current row
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].fromDateInsp`, value);
                                      // copy to index 0 & 2
                                      [0, 2].forEach((i) => {
                                        degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${i}].fromDateInsp`, value);
                                      });
                                    }}
                                  />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].fromDateInsp`} component="div" className="text-danger" />
                                </td>

                                {/* To Date */}

                                <td>
                                  <Field
                                    type="date"
                                    name={`nonScrutinyModalFields[${index}].toDateInsp`}
                                    className="form-control"
                                    min={degreeUniFormik.values.nonScrutinyModalFields[index]?.fromDateInsp || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // update current row
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${index}].toDateInsp`, value);
                                      // copy to index 0 & 2
                                      [0, 2].forEach((i) => {
                                        degreeUniFormik.setFieldValue(`nonScrutinyModalFields[${i}].toDateInsp`, value);
                                      });
                                    }}
                                  />
                                  <ErrorMessage name={`nonScrutinyModalFields[${index}].toDateInsp`} component="div" className="text-danger" />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {/* **************Team Member Details*********** */}
                        <h5 className="mb-3 innerheader-new">
                          <span>Team Member Details</span>
                        </h5>

                        <table className="table table-bordered mt-2">
                          <thead className="table-primary">
                            <tr>
                              <th>Member Details</th>
                              <th>Designation</th>
                              <th>Contact No</th>
                              <th>Email Id</th>
                              <th>CFMS id/Emp id</th>
                              <th>Member College Name</th>
                              <th>College Assigned</th>
                              <th>From Date</th>
                              <th>To Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <Field
                                  as="select"
                                  name={`nonScrutinyModalFields[0].officerName`}
                                  className="form-control"
                                  onChange={(e) => {
                                    const selectedName = e.target.value;

                                    degreeUniFormik.setFieldValue(`nonScrutinyModalFields[0].officerName`, selectedName);

                                    const selectedRow = conData.find((item) => item.principal_name === selectedName);

                                    if (selectedRow) {
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[0].designation`, selectedRow.designation || "Principal");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[0].gmail`, selectedRow.email || "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[0].mobileNo`, selectedRow.mobile || "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[0].conClgName`, selectedRow.coll_name || "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[0].cfmsIdNo`, selectedRow.cfms_id || "-");
                                    }
                                  }}
                                >
                                  <option value="">--Select --</option>

                                  {conData && conData.length > 0 ? (
                                    conData
                                      .filter((item) => !assignedTeamData.physical?.includes(item.principal_name))
                                      .map((item, idx) => (
                                        <option key={idx} value={item.principal_name}>
                                          {item.principal_name}-{item.short_name_college}
                                        </option>
                                      ))
                                  ) : (
                                    <option value="">No Data Available</option>
                                  )}
                                </Field>

                                <ErrorMessage name={`nonScrutinyModalFields[0].officerName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <td>
                                  <Field name={`nonScrutinyModalFields[0].designation`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyModalFields[0].designation`} component="div" className="text-danger" />
                                </td>
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[0].mobileNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[0].mobileNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[0].gmail`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[0].gmail`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[0].cfmsIdNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} />
                                <ErrorMessage name={`nonScrutinyModalFields[0].cfmsIdNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[0].conClgName`} className="form-control" onPaste={handlePaste} disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[0].conClgName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <input value={InstName} disabled className="form-control" />
                                <Field type="hidden" name={`nonScrutinyModalFields[0].collegeAssigned`} value={InstName} />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyModalFields[0].fromDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[0].fromDateInsp`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyModalFields[0].toDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[0].toDateInsp`} component="div" className="text-danger" />
                              </td>
                            </tr>

                            <tr>
                              {/* Team Head */}
                              <td>
                                <Field
                                  as="select"
                                  name={`nonScrutinyModalFields[2].officerName`}
                                  className="form-control"
                                  onChange={(e) => {
                                    const selectedName = e.target.value;

                                    // Set selected officer name
                                    degreeUniFormik.setFieldValue(`nonScrutinyModalFields[2].officerName`, selectedName);

                                    // Find selected row
                                    const selectedRow = polyData.find((item) => item.principal_name === selectedName);

                                    // Set remaining fields
                                    if (selectedRow) {
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[2].designation`, selectedRow.designation || "Principal");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[2].gmail`, selectedRow.email_id || "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[2].mobileNo`, selectedRow.mobile || "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[2].conClgName`, selectedRow.inst_name || "");
                                      degreeUniFormik.setFieldValue(`nonScrutinyModalFields[2].cfmsIdNo`, selectedRow.cfms_id || "-");
                                    }
                                  }}
                                >
                                  <option value="">--Select --</option>

                                  {polyData && polyData.length > 0 ? (
                                    polyData
                                      .filter((item) => !assignedTeamData.physical?.includes(item.principal_name))
                                      .map((item, idx) => (
                                        <option key={idx} value={item.principal_name}>
                                          {item.principal_name}-{item.inst_name}-{item.dist}
                                        </option>
                                      ))
                                  ) : (
                                    <option value="">No Data Available</option>
                                  )}
                                </Field>

                                <ErrorMessage name={`nonScrutinyModalFields[2].officerName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[2].designation`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[2].designation`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[2].mobileNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[2].mobileNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[2].gmail`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[2].gmail`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[2].cfmsIdNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} />
                                <ErrorMessage name={`nonScrutinyModalFields[2].cfmsIdNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyModalFields[2].conClgName`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[2].conClgName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <input value={InstName} disabled className="form-control" />
                                <Field type="hidden" name={`nonScrutinyModalFields[2].collegeAssigned`} value={InstName} />
                                <ErrorMessage name={`nonScrutinyModalFields[2].collegeAssigned`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyModalFields[2].fromDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[2].fromDateInsp`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyModalFields[2].toDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyModalFields[2].toDateInsp`} component="div" className="text-danger" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}
                  </FieldArray>

                  <div className="d-flex justify-content-end mt-3">
                    <bie.Button type="submit" variant="success" onClick={handleSubmitWithTouch}>
                      Save Data
                    </bie.Button>
                  </div>
                </bie.Modal.Body>
              </bie.Modal>

              {/* ********** Scrutiny Modal Popup******** */}
              <bie.Modal show={scrutinyModal} onHide={handleScrutinyClose} size="xl">
                <bie.Modal.Header closeButton style={{ backgroundColor: "#bbc2e9" }}>
                  <bie.Modal.Title>Assigning Inspection Team to {InstName} College</bie.Modal.Title>
                </bie.Modal.Header>
                <bie.Modal.Body>
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                      <label className="field-mandatory">
                        {" "}
                        <b>Online Scrutiny Team</b>
                      </label>
                      <Field as="select" name="scrutinyTeam" className="form-control">
                        <option value="">-- Select Scrutiny Team --</option>
                        {scrutinydata
                          ?.filter((item) => !assignedTeamData.online?.includes(item.emp_name) && !assignedTeamData.online?.includes(item.cfms_id))
                          .map((item) => (
                            <option key={item.cfms_id} value={item.cfms_id}>
                              {item.emp_name} - {item.cfms_id}
                            </option>
                          ))}
                      </Field>
                      <ErrorMessage name="scrutinyTeam" component="div" className="text-danger" />
                    </bie.Col>
                  </bie.Row>

                  {/* Table */}
                  {selectedScrutinyMember && (
                    <bie.Row className="mt-3">
                      <bie.Col xs={12}>
                        <div className="table-responsive">
                          <table className="table table-bordered w-100">
                            <thead className="table-primary text-center">
                              <tr>
                                <th>CFMS ID</th>
                                <th>Employee Name</th>
                                <th>Designation</th>
                                <th>Mobile No</th>
                                <th>Email ID</th>
                                <th>Assigned College</th>
                              </tr>
                            </thead>
                            <tbody className="text-center">
                              <tr>
                                <td>{selectedScrutinyMember.cfms_id}</td>
                                <td>{selectedScrutinyMember.emp_name}</td>
                                <td>{selectedScrutinyMember.designation}</td>
                                <td>{selectedScrutinyMember.mobile}</td>
                                <td>{selectedScrutinyMember.emailid}</td>
                                <td>{InstName}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </bie.Col>
                    </bie.Row>
                  )}
                  <div className="d-flex justify-content-end mt-3">
                    <bie.Button type="submit" variant="success" onClick={handleSubmitWithTouch}>
                      Save Data
                    </bie.Button>
                  </div>
                </bie.Modal.Body>
              </bie.Modal>
            </bie.Row>
          </Form>
        </FormikProvider>
      </bie.Container>
    </>
  );
}
